export default "__VITE_ASSET__BP_nOi8X__"